import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { NavLink, Link, useNavigate } from "react-router-dom";

const Inicio = (props) => {
	const usuario = useSelector((state) => state.usuario)
	const navigate = useNavigate();
	
	useEffect(() => {
		window.scrollTo(0, 0);
		console.log("ENTRO A INICIO")
		console.log(usuario)
		if(usuario.user){
			console.log("YA TIENE EL USER")
			console.log(usuario.user)
			if(usuario.user.id === 147 || usuario.user.tipo === 7){
				navigate('/calendario_eventos/1', { replace: true })
				return
			} else if(usuario.user.rol && usuario.user.rol === 5){
				navigate('/surf_reports', { replace: true })
			} else if(usuario.user.rol &&  usuario.user.rol === 6){
				navigate('/yoga_reports', { replace: true })
			} else if(usuario.user.rol &&  usuario.user.rol === 8){
				navigate('/tasks', { replace: true })
			}else{
				navigate('/dashboard', { replace: true })
			}
		}
	});

    return <>
        <h1>Loading...</h1>
    </>
}

export default Inicio